import { render, staticRenderFns } from "./Vue2EditorComponent.vue?vue&type=template&id=6f35b845&scoped=true"
import script from "./Vue2EditorComponent.vue?vue&type=script&lang=js"
export * from "./Vue2EditorComponent.vue?vue&type=script&lang=js"
import style0 from "./Vue2EditorComponent.vue?vue&type=style&index=0&id=6f35b845&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f35b845",
  null
  
)

export default component.exports